import Vue from 'vue'
import store from '@/store'
import JWT from "@/js/jwtDecode"
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Links from '../views/Links.vue'
import LinkSent from '../views/LinkSent.vue'
import Register from '../views/Register.vue'
import Landing from '../views/Landing.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  }, 
  {
    path: '/sent',
    name: 'sent',
    component: LinkSent
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component : () => import('../views/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      //si el token está en la url lo guardamos en localstorage
      if(to.query.token){
        window.localStorage.setItem('mr-jwt',to.query.token)
      }
      var resp = window.localStorage.getItem('mr-jwt')
      // si no tiene token vamos a logn
      if(!resp)
        next({name:"Login"}) 
      //si tiene token  iniciamos con su session
      else{
        store.commit('setSession',JWT.decode(resp))
        next()     
      }
    }
  },
  {
    path: '/:name',
    name: 'Links',
    component: Links
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
